import React from "react";

export default function DisplayFieldValue({ input, defaultValue = null }) {
  return (
    <>{input.value ? input.value : defaultValue}</>
  )
}